module.exports = __webpack_public_path__ + "img/blueClock.7e61f915.svg";